export enum GeneralCodeType {
  ScreenCategory = 'screenCategory',
  TicketTopic = 'ticketTopic',
  TicketSubTopic = 'ticketSubTopic',

  SystemTicketTopic = 'systemTicketTopic',
  SystemTicketSubTopic = 'systemTicketSubTopic',


  EmailCategory = 'emailCategory',

  SettingCategory = 'settingCategory',
  
  AttributeCategory = 'attributeCategory',
  UnmatchReason = 'unmatchReason',

  ContentCategory = 'contentCategory',
  RoleType = 'roleType',

  BoSettingsPage = 'boSettingsPage',
}

export class GeneralCode {
  id: number;
  name: string;
  type: GeneralCodeType;
  isActive:boolean
  ordinal: number;
}
